export class PayrollPreviewVM {
    id: number;
    name: string;
    phone: string;
    accountNumber: string;
    branchId: number;
    departmentId: number;
    allowances: number;
    deductions: number;
    netSalary: number;
    netAmount: number;
    deductionRefs: DeductionsRef[]
    recurringDeductionsRef: RecurringDeductionsRef[]
    hasChanged?: "allowances" | "deductions"
    subBranchId?: number;
    employeeCategory?: string;
    absenceDays?: number;
    absenceAmount?: number;
}

export class DeductionsRef {
    id: number;
    monthlyInstallment: number
}

export class RecurringDeductionsRef {
    type: string;
    value: number;
    amount: number;
}

// Recurring deductions (percentage/value types) are applied every payroll; everything else in
// `deductions` is loan installments.
export const recurringDeductionsTotal = (p: Pick<PayrollPreviewVM, "recurringDeductionsRef">) =>
    (p.recurringDeductionsRef ?? []).reduce((sum, r) => sum + (r?.amount ?? 0), 0);

export const loansTotal = (p: Pick<PayrollPreviewVM, "deductions" | "recurringDeductionsRef">) =>
    (p.deductions ?? 0) - recurringDeductionsTotal(p);

export class PayrollSuspensionResponseDTO {
    id: number;
    period: string;
    employeeName: string;
    employeeId: number;
    remarks: string;
}